<template>
  <v-row ref="editForm"
         class="edit-form"
         no-gutters>

    <v-col cols="12"
           sm="6">
      <v-text-field v-model.trim="userForm.loginname"
                    v-validate="{required: true, min: 3, max: 30, 'alpha_num': true, regex: /(?=.*[a-zA-Z])(?!^L[0-9]*$)/, 'login-name': true}"
                    :error-messages="errors.collect('loginname')"
                    data-vv-as="Anmeldename"
                    data-vv-validate-on="blur"
                    class="required"
                    name="loginname"
                    label="Wählen Sie Ihren Anmeldenamen" />
    </v-col>

  </v-row>
</template>
<script>
import ValidationMixin from "@/components/helper/ValidationMixin";

export default {
  name: "EditKontakt",
  mixins: [ValidationMixin],
  props: {
    userForm: {
      type: Object,
      required: true
    }
  }
};
</script>
